module.exports = __webpack_public_path__ + "static/media/1040710700.ff41de31.jpg";